import LaneConfig from "./LaneConfig";

export default class SectionConfig {
    /**@type {Array<LaneConfig>} */
    get lanes() {
        return this._lanes;
    }

    /**@returns {LaneConfig} */
    getLane(idx) {
        return this._lanes[idx];
    }

    /**@type {{skin:string, position:Number}} */
    get marker() {
        return this._marker;
    }

    /** @type {boolean} */
    get roadDividers() {
        return this._roadDividers;
    }

    /**@type {string} */
    get action() {
        return this._action;
    }

    /**@type {Number} Speed of fastest lane*/
    get speedMax() {
        return this._speedMax;
    }

    /**@type {Number} Index of fastest lane*/
    get fastestLaneIndex() {
        return this._fastestLaneIndex;
    }

    static fromObject(obj) {
        //Example:
        //   { "speeds": [1, 1, 1, 1], "laneSkins": [4, 5, 4, 5], "lanes": "fx, Fx, fx, Fx", "marker": {"skin":"MarkerStart", "position": -120}, "action": "start"},  
        const res = new SectionConfig();
        let maxSpeed = -1, maxSpeedLaneIndex = -1;
        res._lanes = obj.lanes.split(",").map((laneStr, idx) => {
            const [color, shape] = laneStr.trim().split("");
            const speed = obj.speeds[idx];
            if (speed > maxSpeed) {
                maxSpeed = speed;
                maxSpeedLaneIndex = idx;
            }
            return new LaneConfig(color, shape, speed);
        });
        res._speedMax = maxSpeed;
        res._fastestLaneIndex = maxSpeedLaneIndex;
        res._marker = obj.marker;
        res._action = obj.action;
        res._roadDividers = obj.roadDividers;
        return res;
    }
};
